// extracted by mini-css-extract-plugin
export default {"wrapper":"ElleMurmura_wrapper__NChKR","elleMurmura":"ElleMurmura_elleMurmura__bh2Kw","question":"ElleMurmura_question__d4Jgu","paragraph":"ElleMurmura_paragraph__UP8NS"};